<template>
  <div>
    <t-form label-width="80px">
      <CptData :data="props.attribute.cptTableData" :cptDataForm="props.cptDataForm">
        <t-button style="margin-left: 80px;margin-top:10px;" size="small" @click="addCptTableData">添加字段</t-button>
      </CptData>

      <e-collapse title="地图配置" :expand="true">
        <t-form-item label="地图缩放级别">
          <t-input-number v-model="props.attribute.zoom" :min="3" size="large" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="地图类型">
          <t-select v-model="props.attribute.mapType" size="small">
            <t-option label="普通" value="BMAP_NORMAL_MAP" />
            <t-option label="卫星" value="BMAP_SATELLITE_MAP" />
            <t-option label="卫星+路网" value="BMAP_HYBRID_MAP" />
            <t-option label="地球模式" value="BMAP_EARTH_MAP" />
            <t-option label="自定义蓝色" value="lanse" />
            <t-option label="自定义修文" value="xiuwen" />
          </t-select>
        </t-form-item>
        <!-- <t-form-item label="中心坐标X轴">
          <t-input-number v-model="props.attribute.centerx" :step="0.000001" size="large" :decimal-places="6" />
        </t-form-item>
        <t-form-item label="中心坐标y轴">
          <t-input-number v-model="props.attribute.centery" :step="0.000001" size="large" :decimal-places="6" />
        </t-form-item> -->
        <t-form-item label="文本显示">
          <t-switch @change="handChange" v-model="props.attribute.showname" size="small" :label="['开', '关']" />
        </t-form-item>
        <t-form-item label="文本颜色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.textColor" enableAlpha
            size="small" />
        </t-form-item>
        <t-form-item label="文字大小">
          <t-input-number :min="12" :max="200" v-model="attribute.textSize" size="small" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="缩放按钮显示">
          <t-switch v-model="attribute.zoomCtrlShow" size="small" :label="['显示', '隐藏']" />
        </t-form-item>

        <!-- <t-form-item label="中心点显示">
          <t-switch @change="handChange" v-model="props.attribute.showCenterPoint" size="small" :label="['开', '关']" />
        </t-form-item> -->
        <!-- <t-form-item label="地图样式地址">
          <t-textarea v-model="props.attribute.tareaValue" placeholder="请输入内容" />
        </t-form-item> -->
        <!-- <t-form-item label="">
          <t-link href="https://api.map.baidu.com/">自定义地图平台</t-link>
        </t-form-item> -->
        <t-form-item label="图库选择">
          <div @click="showGallery('url')" style="width: 168px; height: 160px">
            <t-image style="width: 25%; height: 25%;  background: none"
              :src="attribute.url ? fileUrl + attribute.url : require('@/assets/custom/choose_place.png')" fit="fill" />
          </div>
        </t-form-item>
        <t-form-item label="图片宽度">
          <t-input-number size="small" :min="0" :max="9999" v-model="attribute.width" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="图片高度">
          <t-input-number size="small" :min="0" :max="9999" v-model="attribute.height" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="标签横向偏移">
          <t-input-number size="small" :min="-99999" :max="99999" v-model="attribute.labelOffsetY"
            :decimal-places="0" />

        </t-form-item>
        <t-form-item label="标签纵向偏移">
          <t-input-number size="small" :min="-99999" :max="99999" v-model="attribute.labelOffsetX"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="标签宽度">
          <t-input-number size="small" :min="-99999" :max="99999" v-model="attribute.labelWidth"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="标签背景色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.labelBgColor" enableAlpha
            size="small" />
        </t-form-item>
        <t-form-item label="标签边框色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.labelBorderColor" enableAlpha
            size="small" />
        </t-form-item>

      </e-collapse>
      <e-collapse title="加载配置" :expand="true">
        <t-form-item label="加载背景颜色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.loadBg" enableAlpha
            size="small" />
        </t-form-item>
        <t-form-item label="查询弹窗信息">
          <t-switch v-model="attribute.isQueryDetail" size="small" :label="['开', '关']" />
        </t-form-item>
      </e-collapse>


      <e-collapse title="条件配色" :expand="true">
        <t-form-item label="新版条件">
          <t-button @click="addIfEventPopup">设置条件</t-button>
        </t-form-item>

        <span style="padding-left: 7px;padding-bottom: 15px;display: inline-block;">老版条件</span>
        <div style="width: 100%;text-align: center;margin-bottom: 10px"><!--告警配置、环形图/进度图-->
          <t-row>
            <t-col :span="4">字段</t-col>
            <t-col :span="2">条件</t-col>
            <t-col :span="5"></t-col>
          </t-row>
          <t-row style="margin-top: 14px;">
            <t-col :span="4">
              <t-input v-model="attribute.lightField" size="small" style="width: 80px;" />
            </t-col>
            <t-col :span="3">
              <t-select v-model="attribute.operator" size="small" style="width: 60px;">
                <!-- <t-option value=">" label=">"/>
                <t-option value="<" label="<"/> -->
                <t-option value="=" label="=" />
                <!-- <t-option value=">=" label=">="/>
                <t-option value="<=" label="<="/> -->
              </t-select>
            </t-col>
            <t-col :span="5">
              级联参数值
              <!-- <t-input v-model="attribute.threshold" size="small" style="width: 100%;"/> -->
            </t-col>
          </t-row>
        </div>
        <t-form-item label="图片宽度">
          <t-input-number size="small" :min="0" :max="9999" v-model="attribute.lightWidth" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="图片高度">
          <t-input-number size="small" :min="0" :max="9999" v-model="attribute.lightHeight" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="文本颜色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.lightTextColor" enableAlpha
            size="small" />
        </t-form-item>
        <t-form-item label="文字大小">
          <t-input-number :min="12" :max="200" v-model="attribute.LightTextSize" size="small" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="标签背景色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.LightLabelBgColor" enableAlpha
            size="small" />
        </t-form-item>
        <t-form-item label="标签边框色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.LightLabelBorderColor"
            enableAlpha size="small" />
        </t-form-item>
      </e-collapse>
      <e-collapse title="下钻配置" :expand="true">
        <t-form-item label="下钻">
          <t-switch v-model="props.attribute.mapDrillDown" @change="mapDrillDownChange" size="small"
            :label="['开', '关']" />
        </t-form-item>
        <template v-if="props.attribute.mapDrillDown">
          <e-collapse title="字段配置" :expand="true">
            <t-form-item :label="item.name" v-for="(item, index) in props.attribute.sonCptTableData" :key="index">
              <t-select v-model="item.value" size="small" filterable :placeholder="`请选择${item.name}`" clearable>

                <t-option v-for="(ele, eindex) in dataSetData" :key="eindex" :label="ele.COLUMN_NAME"
                  :value="ele.COLUMN_NAME" />
              </t-select>

            </t-form-item>
            <!-- <t-form-item>
              <t-button size="small" @click="choiceDataset">选择数据集</t-button>
            </t-form-item>  -->
          </e-collapse>
          <e-collapse title="子级配置" :expand="true">
            <t-form-item label="点击事件">
              <t-switch v-model="props.attribute.mapClick" size="small" :label="['开', '关']" />
            </t-form-item>
            <t-form-item label="子级缩放级别">
              <t-input-number v-model="props.attribute.sonZoom" :min="8" size="large" :decimal-places="0" />
            </t-form-item>
            <!-- <t-form-item label="缩放事件">
              <t-switch v-model="props.attribute.mapZoom" size="small" :label="['开', '关']" />
            </t-form-item> -->
            <!-- <t-form-item label="缩放触发级别" v-if="props.attribute.mapZoom">
              <t-input-number v-model="props.attribute.drillDownZoom" :min="8" size="large" :decimal-places="0" />
            </t-form-item> -->
            <t-form-item label="下钻查询">
              <t-switch v-model="props.attribute.mapDataSearch" size="small" :label="['开', '关']" />
            </t-form-item>
            <t-form-item label="上级参数字段" v-if="props.attribute.mapDataSearch">
              <t-input size="small" v-model="props.attribute.paramsId" />
            </t-form-item>
          </e-collapse>
          <e-collapse title="子级样式配置" :expand="true">
            <t-form-item label="图库选择">
              <div @click="showGallery('drillDownUrl')" style="width: 168px; height: 160px">
                <t-image style="width: 25%; height: 25%;  background: none"
                  :src="attribute.drillDownUrl ? fileUrl + attribute.drillDownUrl : require('@/assets/custom/choose_place.png')"
                  fit="fill" />
              </div>
            </t-form-item>
            <t-form-item label="图片宽度">
              <t-input-number size="small" :min="0" :max="9999" v-model="attribute.drillDownWidth"
                :decimal-places="0" />
            </t-form-item>
            <t-form-item label="图片高度">
              <t-input-number size="small" :min="0" :max="9999" v-model="attribute.drillDownHeight"
                :decimal-places="0" />
            </t-form-item>
            <t-form-item label="文本颜色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.drillDownTextColor"
                enableAlpha size="small" />
            </t-form-item>
            <t-form-item label="文字大小">
              <t-input-number :min="12" :max="200" v-model="attribute.drillDownTextSize" size="small"
                :decimal-places="0" />
            </t-form-item>
            <t-form-item label="标签背景色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.drillDownLabelBgColor"
                enableAlpha size="small" />
            </t-form-item>
            <t-form-item label="标签边框色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.drillDownLabelBorderColor"
                enableAlpha size="small" />
            </t-form-item>
          </e-collapse>

        </template>


      </e-collapse>
      <e-collapse title="聚合配置">
        <t-form-item label="聚合">
          <t-switch v-model="attribute.pointClusterer" size="small" :label="['开', '关']" />
        </t-form-item>
        <t-form-item label="范围(单位:米)">
          <!-- <t-switch v-model="props.attribute.pointClustererRange" size="small" :label="['开', '关']" /> -->
          <t-input-number v-model="attribute.pointClustererRange" :min="1" size="large" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="聚合文本">
          <!-- <t-switch v-model="attribute.pointClustererText" size="small" :label="['开', '关']" /> -->
          <t-input v-model="attribute.pointClustererText" placeholder="聚合文本" />
        </t-form-item>
        <t-form-item label="图库选择">
          <div @click="showGallery('pointClustererImage')" style="width: 168px; height: 160px">
            <t-image style="width: 25%; height: 25%;  background: none" :src="fileUrl + attribute.pointClustererImage"
              fit="fill" />
          </div>
        </t-form-item>
      </e-collapse>
      <e-collapse title="轨迹配置">
        <t-form-item label="轨迹">
          <t-switch v-model="attribute.polyLine" size="small" :label="['开', '关']" />
        </t-form-item>
        <template v-if="attribute.polyLine">
          <t-form-item label="轨迹动画">
            <t-radio-group v-model="attribute.polyLineAuto" size="small">
              <t-radio-button value="close">关闭</t-radio-button>
              <t-radio-button value="auto">自动</t-radio-button>
              <t-radio-button value="shoudong">手动</t-radio-button>
            </t-radio-group>
          </t-form-item>
          <t-form-item v-if="attribute.polyLineAuto != 'close'" label="动画时长(ms)">
            <t-input-number v-model="attribute.polyLineLenTime" :min="1" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="动画延迟时间(ms)" v-if="attribute.polyLineAuto == 'auto'">
            <t-input-number v-model="attribute.polyLineAutoTime" :min="1" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="轨迹线宽度">
            <t-input-number v-model="attribute.polyLineStrokeWeight" :min="1" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="轨迹线">
            <t-radio-group v-model="attribute.polyLineStyle" size="small">
              <t-radio-button value="lighter">线</t-radio-button>
              <t-radio-button value="image">图片</t-radio-button>
            </t-radio-group>
          </t-form-item>
          <template v-if="attribute.polyLineStyle == 'lighter'">
            <t-form-item label="轨迹颜色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.polyLineColor" enableAlpha
                size="small" />
            </t-form-item>
          </template>
          <template v-else-if="attribute.polyLineStyle == 'image'">
            <t-form-item label="图库选择">
              <div @click="showGallery('polyLineImage')" style="width: 168px; height: 160px">
                <t-image style="width: 25%; height: 25%;  background: none" :src="fileUrl + attribute.polyLineImage"
                  fit="fill" />
              </div>
            </t-form-item>
            <t-form-item label="宽度">
              <t-input-number v-model="attribute.polyLineImageWidth" :min="1" size="small" :decimal-places="0" />
            </t-form-item>
            <t-form-item label="高度">
              <t-input-number v-model="attribute.polyLineImageHeight" :min="1" size="small" :decimal-places="0" />

            </t-form-item>

          </template>
          <t-form-item label="轨迹顺序标签">
            <t-switch v-model="attribute.polyLineLabel" size="small" :label="['开', '关']" />
          </t-form-item>
          <template v-if="attribute.polyLineLabel">
            <t-form-item label="标签背景色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.polyLineLabelBgColor"
                enableAlpha size="small" />
            </t-form-item>
            <t-form-item label="标签边框色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.polyLineLabelBorderColor"
                enableAlpha size="small" />
            </t-form-item>
            <t-form-item label="标签字体色">
              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.polyLineLabelFontColor"
                enableAlpha size="small" />
            </t-form-item>
            <t-form-item label="标签字体大小">
              <t-input-number v-model="attribute.polyLineLabelFontSize" :min="1" size="small" :decimal-places="0" />
            </t-form-item>
            <t-form-item label="标签字体">
              <t-select v-model="attribute.polyLineLabelFontFamily" size="small">
                <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
              </t-select>
            </t-form-item>
          </template>
        </template>


      </e-collapse>



    </t-form>
    <t-dialog header="地图条件配色" v-model:visible="ifEventPopup" class="cpt-dialog" :on-confirm="onConfirmAnother"
      @close="onClose">
      <div class="cpt-dialog-content">



        <div class="row-list-box mt15">
          <div :key="index" v-for="(item, index) in rowDataList"
            :class="index == rowDataList.length - 1 ? 'row-item' : 'row-item bor'">
            <div class="flex-h">
              <div style="flex:1">
                <div class="flex-h mt15">
                  <div class="choose-pop">查询条件</div>
                  <div class="cpt-right">

                    <div class="cpt_param mt15">
                      <div class="cpt_param_ul">
                        <div>字段名称</div>
                        <div>运算符</div>
                        <div>值类型</div>
                        <div>值</div>
                        <div>逻辑</div>
                        <t-icon name="add" @click="addSearchParam(index)" />
                      </div>
                      <div>
                        <div class="cpt_add_param" v-for="(ele, ind) in item.searchFieldArr" :key="ind">
                          <div class="cpt_add_item">
                            <img class="tip" src="@/assets/icon/t.svg" alt="" />
                            <t-select placeholder="请选择" clearable v-model="ele.fieldName" filterable>
                              <t-option v-for="(el2, index2) in fieldNameList" :key="index2" :label="el2.COLUMN_NAME"
                                :value="el2.COLUMN_NAME" />
                            </t-select>
                          </div>
                          <div class="cpt_add_item">
                            <img class="tip" src="@/assets/icon/t.svg" alt="" />
                            <t-select placeholder="请选择" clearable v-model="ele.operator" filterable>
                              <t-option v-for="(el2, index2) in operatorList" :key="index2" :label="el2.name"
                                :value="el2.id" />
                            </t-select>
                          </div>
                          <div class="cpt_add_item">
                            <img class="tip" src="@/assets/icon/t.svg" alt="" />
                            <t-select placeholder="请选择" clearable v-model="ele.fieldType" filterable>
                              <t-option v-for="(el2, index2) in fieldTypeList" :key="index2" :label="el2.name"
                                :value="el2.id" />
                            </t-select>
                          </div>
                          <div class="cpt_add_item">
                            <img class="tip" src="@/assets/icon/t.svg" alt="" />
                            <t-select v-if="ele.fieldType == '数据集'" placeholder="请选择" clearable v-model="ele.fieldVal"
                              filterable>
                              <t-option v-for="(el2, index2) in fieldNameList" :key="index2" :label="el2.COLUMN_NAME"
                                :value="el2.COLUMN_NAME" />
                            </t-select>
                            <t-input v-model="ele.fieldVal" v-else placeholder="请输入" />
                          </div>
                          <div class="cpt_add_item">
                            <img class="tip" src="@/assets/icon/t.svg" alt="" />
                            <t-select placeholder="请选择" clearable
                              :disabled="ind == item.searchFieldArr.length - 1 ? true : false" v-model="ele.logic">
                              <t-option v-for="(el2, index2) in logicList" :key="index2" :label="el2.name"
                                :value="el2.id" />
                            </t-select>
                          </div>
                          <t-icon name="delete" @click="delSearchParam(index, ind, 'searchFieldArr')" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex-h mt15">
                  <div class="choose-pop">设置样式</div>
                  <div class="cpt-right">
                    <div class="cpt_param mt15">
                      <template v-for="(ele, ind) in item.updateFieldArr">
                        <div class="cpt_param_ul">
                          <div>图片宽度</div>
                          <div>图片高度</div>
                          <div>文字大小</div>
                          <div>标签背景色</div>
                          <div>标签边框色</div>

                          <!-- <t-icon name="add" @click="addUpdateParam(index)" /> -->
                        </div>
                        <div>
                          <div class="cpt_add_param" :key="ind">
                            <div class="cpt_add_item setStyle">
                              <t-input-number v-model="ele.imageWidth" />
                            </div>
                            <div class="cpt_add_item setStyle">
                              <t-input-number v-model="ele.imageHeight" />
                            </div>
                            <div class="cpt_add_item setStyle">
                              <t-input-number v-model="ele.fontSize" />
                            </div>
                            <div class="cpt_add_item setStyle">
                              <img class="tip" src="@/assets/icon/t.svg" alt="" />
                              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="ele.labelBgColor"
                                enableAlpha size="small" />
                            </div>
                            <div class="cpt_add_item setStyle">
                              <img class="tip" src="@/assets/icon/t.svg" alt="" />
                              <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="ele.labelBorderColor"
                                enableAlpha size="small" />
                            </div>
                            <!-- <t-icon name="delete" @click="delSearchParam(index, ind, 'updateFieldArr')" /> -->
                          </div>
                        </div>
                        <div class="cpt_param_ul" style="margin-top:10px;">
                          <div>图标</div>
                          <div>聚合图标</div>
                          <div>轨迹运动图标</div>
                        </div>
                        <div>
                          <div class="cpt_add_param" :key="ind">
                            <div class="cpt_add_item setStyle setStyleImage">
                              <div @click="showGalleryEle(['iconImage', index, ind])"
                                style="width: 80px; height: 80px;">
                                <t-image style="width: 100%; height: 100%;  background: none"
                                  :src="fileUrl + ele.iconImage" fit="fill" />
                              </div>
                            </div>
                            <div class="cpt_add_item setStyle setStyleImage">
                              <div @click="showGalleryEle(['clustererImage', index, ind])"
                                style="width: 80px; height: 80px;">
                                <t-image style="width: 100%; height: 100%;  background: none"
                                  :src="fileUrl + ele.clustererImage" fit="fill" />
                              </div>
                            </div>
                            <div class="cpt_add_item setStyle setStyleImage">
                              <div @click="showGalleryEle(['polyLineImage', index, ind])"
                                style="width: 80px; height: 80px;">
                                <t-image style="width: 100%; height: 100%;  background: none"
                                  :src="fileUrl + ele.polyLineImage" fit="fill" />
                              </div>
                            </div>
                          </div>
                        </div>

                      </template>


                    </div>
                  </div>

                </div>
              </div>
              <div style="margin-left: 20px; font-size: 20px;"><t-icon name="delete" @click="delRowParam(index)" />
              </div>
            </div>
          </div>
          <div class="flex-h-center" style="padding: 0 0 10px; font-size: 26px;"><t-icon name="add"
              @click="addRowParam()" />
          </div>
        </div>

        <!-- <div class="flex-h mt15">
      <div class="choose-pop">是否调用网络请求</div>

      <t-switch v-model="backHttp"/>
    </div> -->

        <dataset-dialog ref="dataset-dialog" @datasetConfirm="datasetConfirm" />


      </div>
    </t-dialog>
    <Gallery ref="gallery" @confirmCheck="confirmCheck" />
  </div>
</template>

<script setup>
import env from "/env";
import { ref, onMounted, watch } from "vue";
import Gallery from "@/components/designer/gallery";
import CptData from "@/components/element/options/comp/cpt-data";
import { getDetailApi } from "@/api/dataset/dataset-sql";
import { executeSelectKey } from "@/api/sql-execute-api";
import { MessagePlugin } from "tdesign-vue-next";



let gallery = ref(null);
let openGallery = ref(null);
let dataSetData = ref([]);
let fileUrl = ref(env.fileUrl);
let ifEventPopup = ref(false)
// 条件
let operatorList = ref([
  { id: '==', name: '=' },
  { id: '>', name: '>' },
  { id: '>=', name: '>=' },
  { id: '<', name: '<' },
  { id: '<=', name: '<=' },
])
// 字段列表
let fieldNameList = ref([])
// 字段类型
let fieldTypeList = ref([
  { id: '固定值', name: '固定值' },
  { id: 'url', name: 'url' },
  { id: '数据集', name: '数据集' },
])

let logicList = ref([
  { id: '&&', name: '并且' },
  { id: '||', name: '或' },
])
// 地图配色条件数组
let rowDataList = ref([
  {
    searchRow: '当前行',
    searchFieldArr: [
      { fieldName: null, operator: null, fieldType: null, fieldVal: null, logic: '||' }
    ],
    updateFieldArr: [
      { imageWidth: 20, imageHeight: 20, fontSize: 14, labelBgColor: null, labelBorderColor: null, iconImage: null, clustererImage: null, polyLineImage: null }
    ],
  },
])

let props = defineProps({
  attribute: Object,
  cptDataForm: Object,
  currentCpt: Object,
});
let textFamilyList = ref(require('@/assets/font/font-list'))

console.log('sophie', props)
let showGallery = (val) => {
  openGallery.value = val;
  gallery.value.opened();
};

let showGalleryEle = (val) => {
  openGallery.value = val;
  gallery.value.opened();
}

let mapDrillDownChange = (val) => {
  if (val) {
    if (props.cptDataForm && props.cptDataForm.dataSource && String(props.cptDataForm.dataSource) === '4') {
      executeSelectFun(props.cptDataForm);
    }
  }
}
let handChange = (val) => {
  console.log(val)
  console.log(props.attribute.showname)

}
let confirmCheck = (url) => {
  if (Array.isArray(openGallery.value)) {
    let key = openGallery.value;
    rowDataList.value[key[1]].updateFieldArr[key[2]][key[0]] = url
  } else {
    let key = openGallery.value;
    props.attribute[key] = url;
  }
};

let executeSelectFun = (cptDataForm) => {
  getDetailApi(cptDataForm.datasetId)
    .then((res) => {
      // console.log(res,'res')
      let iptstr = res.data.sqlText;
      if (!iptstr) {
        // this.$message.Message.error("SQL不能为空");
        return [];
      }
      // 返回 executeSelectKey 的 Promise 并直接在其 then 中处理结果
      return executeSelectKey({
        sql: iptstr,
        datasourceId: res.data.datasourceId,
        isArray: true,
      });
    })
    .then((result) => {
      // console.log(result, "result");

      // 直接根据 result 数据结构来决定是否赋值以及如何赋值
      if (result && result.data) {
        dataSetData = result.data || [];
        cptDataForm.dataSetData = dataSetData;
      } else {
        dataSetData = [];
      }
    })
    .catch((error) => {
      // this.$message.error("查询数据失败，请稍后重试");
      dataSetData = []; // 当出现错误时，清空或设置为空数组
    });

}

function addIfEventPopup() {
  ifEventPopup.value = true
  rowDataList.value = (props.attribute.rowDataList && props.attribute.rowDataList?.length != 0) ? props.attribute.rowDataList : rowDataList.value
  getFieldNameList()
}

function onClose() {
  console.log('12312ee');
  rowDataList.value = [
    {
      searchRow: '当前行',
      searchFieldArr: [
        { fieldName: null, operator: null, fieldType: null, fieldVal: null, logic: '||' }
      ],
      updateFieldArr: [
        { imageWidth: 20, imageHeight: 20, fontSize: 14, labelBgColor: null, labelBorderColor: null, iconImage: null, clustererImage: null, polyLineImage: null }
      ],
    },
  ]
}

function onConfirmAnother(e) {
  console.log(rowDataList.value, e, 'qwdijqwidjiqdijdqijwdij');
  props.attribute.rowDataList = rowDataList.value
  ifEventPopup.value = false
  rowDataList.value = [
    {
      searchRow: '当前行',
      searchFieldArr: [
        { fieldName: null, operator: null, fieldType: null, fieldVal: null, logic: '||' }
      ],
      updateFieldArr: [
        { imageWidth: 20, imageHeight: 20, fontSize: 14, labelBgColor: null, labelBorderColor: null, iconImage: null, clustererImage: null, polyLineImage: null }
      ],
    },
  ]

}
function delRowParam(index) {
  rowDataList.value.splice(index, 1);
}
function addRowParam() {
  // if (rowDataList.value.length >= 2) {
  //   MessagePlugin.info('最多添加两条！');
  //   return;
  // }
  rowDataList.value.push({
    searchRow: '当前行',
    searchFieldArr: [
      { fieldName: null, operator: null, fieldType: null, fieldVal: null, logic: '||' }
    ],
    updateFieldArr: [
      { imageWidth: 20, imageHeight: 20, fontSize: 14, labelBgColor: null, labelBorderColor: null, iconImage: null, clustererImage: null, polyLineImage: null }
    ],
  },);
}

function delSearchParam(index, index2, type) {
  // updateFieldArr
  console.log(type, 'typetype')
  rowDataList.value[index][type].splice(index2, 1);
}

function addUpdateParam(index) {
  rowDataList.value[index].updateFieldArr.push({ imageWidth: 20, imageHeight: 20, fontSize: 14, labelBgColor: null, labelBorderColor: null, iconImage: null, clustererImage: null, polyLineImage: null });
}



function addSearchParam(index) {
  rowDataList.value[index].searchFieldArr.push({ fieldName: null, operator: null, fieldType: null, fieldVal: null, logic: '||' });
}

function getFieldNameList() {
  if (props.cptDataForm && props.cptDataForm.dataSource && String(props.cptDataForm.dataSource) === '4') {
    executeSelectFun(props.cptDataForm);

    fieldNameList.value = props.cptDataForm.dataSetData

  }
}

function addCptTableData() {
  let nameList = props.attribute.cptTableData.filter(item => item.name.includes('文本显示'))
  props.attribute.cptTableData.push({ "name": `文本显示${nameList.length}`, "value": "", "namekey": `name${nameList.length}`, "delete": true })
}

onMounted(() => {
  getFieldNameList()
})
</script>

<style>
.flex-h {
  display: flex;
  align-items: center;
}

.flex-h-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-h-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-h-around {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.flex-h-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.flex-v {
  display: flex;
  flex-direction: column;
}

.flex-v-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mt15 {
  margin-top: 10px;
}


.row-list-box {
  position: relative;
  padding: 10px;
  /* background: #151927; */
  border-radius: 5px;
}

.row-list-box .row-item {
  padding-bottom: 20px;
}

.row-list-box .row-item.bor {
  border-bottom: 1px solid #363e55;
}


.cpt-dialog /deep/.t-dialog--default {
  padding: 0px !important;
}

.cpt-dialog .t-dialog {
  width: 1000px !important;
}

.cpt-dialog /deep/.t-dialog {
  background-color: #20263b;
  border-radius: 4px;
  border: 1px solid transparent;
  height: 680px;
}

.cpt-dialog /deep/.t-dialog__header {
  height: 40px;
  background-color: #292f45;
  padding-left: 20px;
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.9);
}

.cpt-dialog /deep/.t-dialog__close {
  padding-right: 18px;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 16px;
}

.cpt-dialog /deep/.t-dialog__close:hover {
  background-color: #292f45;
}

.cpt-dialog /deep/.t-dialog__body {
  height: calc(100% - 40px - 44px);
  box-sizing: border-box;
  padding: 10px 20px 0px;
}

.cpt-dialog /deep/.t-dialog__footer {
  height: 44px;
  line-height: 44px;
  padding: 0px 20px 0px 0px;
  box-sizing: border-box;
}

.cpt-dialog /deep/.t-dialog__cancel {
  height: 28px;
  background-color: rgba(44, 96, 219, 0.1);
  border-width: 0;
  color: #2c60db;
  padding: 0px 10px;
  font-size: 12px;
  border-radius: 2px;
}

.cpt-dialog /deep/.t-dialog__confirm {
  color: #fff;
  background-color: #2c60db;
  border: 1px solid #2c60db;
  height: 28px;
  padding: 0px 10px;
  font-size: 12px;
  border-radius: 2px;
}

.cpt-dialog-content {
  width: 100%;
  height: 82%;
  /* display: flex; */
}

.cpt-left {
  width: 150px;
  border: 1px solid #363e55;
  height: 100%;
  box-sizing: border-box;
}

.cpt-left-header {
  height: 30px;
  border-bottom: 1px solid #363e55;
  background-color: #292f45;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.cpt-left-header_title {
  padding-left: 5px;
  line-height: 30px;
}

.cpt-left-header_img {
  padding-right: 5px;
}

.cpt-left-header_img img {
  vertical-align: middle;
  cursor: pointer;
}

.cpt-left-header_img img:last-of-type {
  padding-left: 5px;
}

.cpt-left-main {
  width: 100%;
  padding-top: 5px;
}

.cpt-left-main-item {
  height: 24px;
  width: 100%;
  position: relative;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 12px;
  cursor: pointer;
}

.cpt_intName {
  height: 24px;
  line-height: 24px;
  padding-left: 6px;
  padding-right: 6px;
  text-align: left;
  white-space: pre;
  text-overflow: ellipsis;
  inset: 0px;
  position: absolute;
}


.cpt_param {
  width: 100%;
}

.cpt_param_ul {
  display: flex;
  flex-direction: row;
  height: auto;
  line-height: 24px;
  align-items: center;
}

.cpt_param_ul .t-icon {
  color: #606479;
  font-size: 18px;
  margin-left: 10px;
  cursor: pointer;
}

.cpt_param_ul div:first-of-type {
  margin-left: 0px;
}

.cpt_param_ul div {
  background-color: rgba(35, 190, 239, 0.1);
  color: #d6e0dc;
  font-size: 12px;
  width: 150px;
  margin-right: 10px;
  text-indent: 10px;
}

.cpt_add_param {
  width: 100%;
  display: flex;
  margin-top: 5px;
  align-items: center;
}

.cpt_add_item {
  font-size: 12px;
  width: 150px;
  margin-right: 10px;
  position: relative;
}

.cpt_add_item:first-of-type {
  margin-left: 0px;
}

.cpt_add_item img.tip {
  position: absolute;
  top: 6px;
  left: 9px;
  z-index: 1;
}

.cpt_add_item .t-input {
  height: auto;
  line-height: 24px !important;
  padding-left: 25px;
}

.yuan /deep/.t-input {
  border-radius: 24px;
}

.cpt_add_param .t-icon {
  color: #606479;
  font-size: 17px;
  margin-left: 10px;
  cursor: pointer;
}

.cpt_xuanz {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
}

.cpt_xuanz span {
  font-size: 12px;
  color: #d6e0dc;
  line-height: 24px;
}

.cpt_xuanz /deep/.t-input__wrap {
  width: calc(100% - 48px - 16px - 20px);
  margin: 0px 10px;
}

.cpt_xuanz /deep/ .t-input {
  height: auto;
  line-height: 24px;
}

.cpt_xuanz /deep/.t-input.t-is-disabled {
  background-color: transparent;
}

.cpt_xuanz img {
  cursor: pointer;
}

.search_input {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

/deep/.t-input__wrap {
  height: 24px;
}

.input_left {
  margin-left: 10px;
}

/deep/.t-input {
  height: 24px;
  font-size: 12px;
  border-color: #363e55 !important;
}

.choose-pop {
  margin-right: 10px;
}


.pop-select {
  flex: 1;
}

.is-dong {
  margin-top: 5px;
}

.setStyle .t-input {
  padding: 0 10px;
}

.setStyle .t-input-number button svg {
  margin: 0;
}

.setStyle .t-input-number button {
  height: 26px;
}

.setStyle .t-color-picker__trigger,
.setStyle .t-color-picker__trigger .t-input__wrap {
  width: 150px !important;
}

.setStyle .t-image__wrapper svg {
  margin-left: unset;
}

.setStyleImage {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>